import React, { Component } from 'react';
import { db } from '../firebase/Firebase';
import ReactToPrint from "react-to-print";
import { flattenDoc } from '../Util';
import ColType from '../Types';
import { Collapse, notification, Button, Icon, Popconfirm } from 'antd';
import Empty from '../customcomponents/Empty';
import moment from 'moment';
import SchoolTeamworkReportForm from './SchoolTeamworkReportForm';
import SchoolTeamworkReportUpdateForm from './SchoolTeamworkReportUpdateForm';
const { Panel } = Collapse;
var html2pdf = null
if (typeof window !== 'undefined') {
    html2pdf = require('html2pdf.js')
}
const successMessage = (description) => {
    notification.open({
        type: 'success',
        message: description,
        placement: 'bottomRight'
    });
};
const errorMessage = (description) => {
    notification.open({
        type: 'error',
        message: description,
        placement: 'bottomRight'
    });
};
class SchoolTeamworkReport extends Component {
    state = {
        reports: [],
        reportsMounted: false,
        reportsListener: null,
    };
    componentDidMount() {
        let reportsListener = db.collection(ColType.schoolTeamworkReport)
            .where('districtId', '==', this.props.districtId)
            .where('schoolId', '==', this.props.schoolId)
            .where('timeStamp', '>=', new Date('2026-07-01T00:00:00Z'))
            .orderBy('timeStamp', 'desc')
            .limit(50)
            .onSnapshot((querySnapshot) => {
                let reports = [];
                querySnapshot.forEach((doc) => {
                    reports.push(flattenDoc(doc));
                });
                this.setState({
                    reports: reports,
                    reportsMounted: true
                });
            });
        this.setState({
            reportsListener: reportsListener
        });
    }
    componentWillUnmount() {
        if (this.state.reportsListener) {
            this.state.reportsListener();
        }
    }
    // Newer reports use coTeachDate, older ones used date. Date + time is no
    // longer collected, so fall back to the creation timeStamp for the header.
    getReportDate = (report) => {
        if (report.coTeachDate && report.coTeachDate.seconds) {
            return moment.utc(report.coTeachDate.seconds * 1000)
        }
        if (report.date && report.date.seconds) {
            return moment.utc(report.date.seconds * 1000)
        }
        if (report.timeStamp && report.timeStamp.seconds) {
            return moment.utc(report.timeStamp.seconds * 1000)
        }
        return null
    }
    getCoachName = (report) => {
        return [report.coachFirstName, report.coachLastName].filter(Boolean).join(' ')
    }
    // Label a row by its focus area, falling back to legacy grade/subject fields.
    getReportLabel = (report) => {
        if (report.focusArea) {
            return report.focusArea
        }
        if (report.gradeLevel || report.subject) {
            return ['Grade ' + report.gradeLevel, report.subject].filter(Boolean).join(' · ')
        }
        return 'Coaching report'
    }
    getFileName = (report) => {
        let reportDate = this.getReportDate(report)
        let datePart = reportDate ? reportDate.format("MM-DD-YYYY") : 'current'
        return `Coaching-Report-${datePart}.pdf`
    }
    render() {
        return (
            <div className="coaching-report-container">
                <div className="header-section">
                    <div className="header-copy">
                        <h1 className="page-title">Coaching Report</h1>
                        <div className="page-subtitle">Your coaching plan for the week and what you learned from coaching.</div>
                    </div>
                    <SchoolTeamworkReportForm
                        districtId={this.props.districtId}
                        schoolId={this.props.schoolId}
                        personId={this.props.personId}
                    />
                </div>
                <div className="callout">
                    <Icon type='schedule' className="callout-icon" />
                    <div>
                        <div className="callout-title">Plan your week, then capture what happened</div>
                        <div className="callout-text">Note the grade level or content area you're solving, the data behind it, and who you're coaching with. Open a report to edit, print, or download it.</div>
                    </div>
                </div>
                <div className="reports-section">
                    {this.state.reportsMounted ?
                        this.state.reports.length === 0 ?
                            <Empty
                                containerClassName="empty-state"
                                width={55}
                                height={55}
                                image={'/empty/goals.png'}
                                description={'No coaching reports yet. Add your first report to get started.'}
                            />
                            :
                            <Collapse bordered={false} className="reports-collapse">
                                {this.state.reports.map((report) => {
                                    let contentRefName = 'content-' + report.id;
                                    let reportDate = this.getReportDate(report);
                                    let coachName = this.getCoachName(report);
                                    return (
                                        <Panel
                                            header={
                                                <div className="report-header">
                                                    <div className="report-title">
                                                        {coachName ?
                                                            <span className="focus-label">{coachName}</span>
                                                            : <span className="focus-label">{this.getReportLabel(report)}</span>}
                                                    </div>
                                                    <div className="report-date">
                                                        {reportDate ? reportDate.format("MMM DD, YYYY") : ''}
                                                    </div>
                                                </div>
                                            }
                                            key={report.id}
                                            className="report-panel"
                                        >
                                            <div className="report-content">
                                                <div className="action-buttons">
                                                    <SchoolTeamworkReportUpdateForm
                                                        districtId={this.props.districtId}
                                                        schoolId={this.props.schoolId}
                                                        report={report}
                                                    />
                                                    <ReactToPrint
                                                        trigger={() =>
                                                            <Button type="default" size='large' className="action-btn">
                                                                <Icon type="download" /> Download PDF
                                                            </Button>
                                                        }
                                                        content={() => this[contentRefName]}
                                                        print={async (printIframe) => {
                                                            if (!html2pdf) {
                                                                return new Promise((resolve, reject) => { resolve() })
                                                            }
                                                            const document = printIframe.contentDocument
                                                            if (document) {
                                                                const html = document.getElementsByTagName('html')[0]
                                                                await html2pdf().from(html).set({
                                                                    image: { type: 'png', quality: 1.0 },
                                                                    html2canvas: { scale: 1.0 },
                                                                    margin: 12,
                                                                    pagebreak: { mode: ['avoid-all', 'css'] },
                                                                }).save(this.getFileName(report))
                                                            }
                                                            return new Promise((resolve, reject) => { resolve() })
                                                        }}
                                                    />
                                                    <ReactToPrint
                                                        trigger={() => (
                                                            <Button type="default" size='large' className="action-btn">
                                                                <Icon type="printer" /> Print
                                                            </Button>
                                                        )}
                                                        content={() => this[contentRefName]}
                                                    />
                                                    {this.props.personId === report.personId &&
                                                        <Popconfirm
                                                            title="Delete this report?"
                                                            onConfirm={() => {
                                                                db.collection(ColType.schoolTeamworkReport)
                                                                    .doc(report.id)
                                                                    .delete()
                                                                    .then(() => {
                                                                        successMessage('Report deleted.');
                                                                    })
                                                                    .catch((error) => {
                                                                        console.log(error);
                                                                        errorMessage('Error deleting report. Please try again.');
                                                                    });
                                                            }}
                                                            okText="Delete"
                                                            cancelText="Cancel"
                                                        >
                                                            <Button type="danger" className="delete-btn">
                                                                <Icon type="delete" />
                                                            </Button>
                                                        </Popconfirm>
                                                    }
                                                </div>
                                                <div ref={el => (this[contentRefName] = el)} className="printable-content">
                                                    <div className="report-document">
                                                        <div className="document-header">
                                                            <img src="/dotit-logo-color-new.png" alt="logo" className="logo" />
                                                            <h2>Coaching Report</h2>
                                                            <div className="report-meta">
                                                                {coachName ? <span>Coach: {coachName}</span> : ''}
                                                                <span>Date: {reportDate ? reportDate.format("MM/DD/YYYY") : ''}</span>
                                                            </div>
                                                        </div>
                                                        <div className="report-sections">
                                                            <div className="section">
                                                                <div className="section-header">
                                                                    <h3>Which grade level/content area are you solving in this plan that is connected to your school improvement goals?</h3>
                                                                </div>
                                                                <div className="section-content">
                                                                    {report.focusArea}
                                                                </div>
                                                            </div>
                                                            <div className="section">
                                                                <div className="section-header">
                                                                    <h3>What data is informing your coaching practice this week?</h3>
                                                                </div>
                                                                <div className="section-content">
                                                                    {report.dotItData}
                                                                </div>
                                                            </div>
                                                            <div className="section">
                                                                <div className="section-header">
                                                                    <h3>What steps will you take to solve the problem? Include days and times</h3>
                                                                </div>
                                                                <div className="section-content">
                                                                    {report.solutionSteps}
                                                                </div>
                                                            </div>
                                                            <div className="section">
                                                                <div className="section-header">
                                                                    <h3>Coaching Documentation</h3>
                                                                </div>
                                                                <div className="section-content">
                                                                    {report.coTeachingResults}
                                                                </div>
                                                            </div>
                                                            {report.resourceExplanation ?
                                                                <div className="section">
                                                                    <div className="section-header">
                                                                        <h3>If applicable, upload your district resource on the standard page. Why did you upload this resource?</h3>
                                                                    </div>
                                                                    <div className="section-content">
                                                                        {report.resourceExplanation}
                                                                    </div>
                                                                </div>
                                                                : ''}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Panel>
                                    );
                                })}
                            </Collapse>
                        : <div className="loading">Loading reports...</div>}
                </div>
                <style jsx>{`
                    .coaching-report-container {
                        max-width: 1200px;
                        margin: 0 auto;
                        padding: 20px;
                    }
                    .header-section {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        gap: 24px;
                        margin-bottom: 22px;
                        padding-bottom: 20px;
                        border-bottom: 1px solid #e8eef5;
                    }
                    .header-copy {
                        min-width: 0;
                    }
                    .page-title {
                        font-size: 32px;
                        font-weight: 800;
                        color: #1e293b;
                        margin: 0;
                        letter-spacing: -0.4px;
                    }
                    .page-subtitle {
                        font-size: 16px;
                        color: #475569;
                        margin-top: 4px;
                        line-height: 1.5;
                    }
                    .callout {
                        display: flex;
                        gap: 16px;
                        align-items: center;
                        background: #f0f7ff;
                        border: 1px solid #cfe3ff;
                        border-radius: 16px;
                        padding: 18px 22px;
                        margin-bottom: 22px;
                    }
                    .callout-icon {
                        font-size: 30px;
                        color: #1098f7;
                    }
                    .callout-title {
                        font-size: 20px;
                        font-weight: 800;
                        color: #1e293b;
                        margin-bottom: 2px;
                    }
                    .callout-text {
                        font-size: 16px;
                        color: #475569;
                        line-height: 1.5;
                    }
                    .reports-section {
                        margin-top: 20px;
                    }
                    .empty-state {
                        text-align: center;
                        padding: 60px 20px;
                        color: #475569;
                        background: #fff;
                        border: 1px solid #e8eef5;
                        border-radius: 16px;
                    }
                    .reports-collapse {
                        background: transparent;
                    }
                    :global(.reports-collapse .ant-collapse-item) {
                        margin-bottom: 12px;
                        background: #fff;
                        border: 1px solid #e8eef5 !important;
                        border-radius: 16px;
                        box-shadow: rgba(100, 100, 111, 0.12) 0px 4px 14px 0px;
                        overflow: hidden;
                    }
                    :global(.reports-collapse .ant-collapse-header) {
                        padding: 16px 20px 16px 44px !important;
                        color: #1e293b !important;
                    }
                    .report-header {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                        padding: 2px 0;
                        gap: 12px;
                    }
                    .report-title {
                        display: flex;
                        align-items: center;
                        gap: 12px;
                        flex: 1;
                        min-width: 0;
                    }
                    .focus-label {
                        font-weight: 700;
                        color: #1e293b;
                        font-size: 18px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        max-width: 460px;
                    }
                    .coach-tag {
                        background: #f0f7ff;
                        border: 1px solid #cfe3ff;
                        color: #1e3a5f;
                        padding: 3px 10px;
                        border-radius: 999px;
                        font-size: 13px;
                        font-weight: 600;
                        white-space: nowrap;
                    }
                    .report-date {
                        color: #64748b;
                        font-size: 14px;
                        white-space: nowrap;
                    }
                    .report-content {
                        padding: 8px 12px 20px 12px;
                    }
                    .action-buttons {
                        display: flex;
                        gap: 10px;
                        margin-bottom: 24px;
                        justify-content: flex-end;
                    }
                    .action-btn {
                        border-radius: 10px;
                        font-weight: 500;
                    }
                    .delete-btn {
                        border-radius: 8px;
                        width: 40px;
                        height: 40px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .printable-content {
                        background: white;
                        border: 1px solid #e8eef5;
                        border-radius: 16px;
                        padding: 30px;
                    }
                    .report-document {
                        max-width: 800px;
                        margin: 0 auto;
                        line-height: 1.6;
                    }
                    .document-header {
                        text-align: center;
                        margin-bottom: 40px;
                        padding-bottom: 20px;
                        border-bottom: 1px solid #e8eef5;
                    }
                    .logo {
                        height: 70px;
                        margin-bottom: 20px;
                    }
                    .document-header h2 {
                        font-size: 28px;
                        font-weight: 800;
                        color: #1e293b;
                        margin: 0 0 16px 0;
                    }
                    .report-meta {
                        display: flex;
                        justify-content: center;
                        gap: 30px;
                        flex-wrap: wrap;
                    }
                    .report-meta span {
                        color: #64748b;
                        font-weight: 500;
                    }
                    .report-sections {
                        display: flex;
                        flex-direction: column;
                        gap: 30px;
                    }
                    .section {
                        border-left: 4px solid #1098f7;
                        padding-left: 20px;
                    }
                    .section-header h3 {
                        color: #1e293b;
                        font-size: 18px;
                        font-weight: 700;
                        margin: 0 0 10px 0;
                        line-height: 1.4;
                    }
                    .section-content {
                        color: #334155;
                        font-size: 16px;
                        white-space: pre-wrap;
                    }
                    .plan-sentence {
                        background: #f8fafc;
                        border: 1px solid #e8eef5;
                        border-radius: 12px;
                        padding: 16px 18px;
                        font-size: 17px;
                        color: #334155;
                        white-space: normal;
                    }
                    .plan-value {
                        font-weight: 700;
                        color: #1098f7;
                    }
                    .loading {
                        text-align: center;
                        padding: 40px;
                        color: #64748b;
                    }
                    @media (max-width: 768px) {
                        .header-section {
                            flex-direction: column;
                            gap: 16px;
                            align-items: flex-start;
                        }
                        .report-header {
                            flex-direction: column;
                            align-items: flex-start;
                            gap: 6px;
                        }
                        .focus-label {
                            max-width: 100%;
                            white-space: normal;
                        }
                        .report-meta {
                            flex-direction: column;
                            gap: 10px;
                        }
                        .action-buttons {
                            flex-wrap: wrap;
                            justify-content: flex-start;
                        }
                    }
                `}</style>
            </div>
        );
    }
}
export default SchoolTeamworkReport;